<div class="activity-container">
  <div class="header" [ngStyle]="{ backgroundColor: color }">
    <!-- <img *ngIf="image" [src]="image" /> -->
    <img src="https://picsum.photos/400/200" />
  </div>
  <div class="content">
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
    <ion-button #validationButton shape="round" (click)="validated.emit(true)">
      {{ buttonLabel }}
    </ion-button>
  </div>
</div>
